import {
  BookingSpaceCancellationOption,
  BookingSpaceCancellationType,
} from '@website/types/graphqlOperations';

/**
 * Get the default cancellation type
 */
export function getDefaultCancellationType(
  options: Array<
    Pick<BookingSpaceCancellationOption, 'type' | 'guestPermission'>
  >,
) {
  const balanceRefundAvailable = options?.some(
    (option) =>
      option.type === BookingSpaceCancellationType.BALANCE_REFUND &&
      option.guestPermission,
  );

  if (balanceRefundAvailable) {
    return BookingSpaceCancellationType.BALANCE_REFUND;
  }
  return BookingSpaceCancellationType.NO_REFUND;
}
